import {ACTION_CODE} from './_actionCode';
import {DashboardService} from '../../../services';
import {ErrorModel, ResultModel} from '../../../models';
import {LoggerService} from '../../../services';
const FUNCTION_CODE = 'GET_SALES';

export async function getSales(userData: Record<string, any>, params: Record<string, any>) {
    try {
        LoggerService.logInfo('Action - getSales - Start');

        const getSales =
            await DashboardService.OfficeManagerService.getSales(userData, params);

        LoggerService.logInfo('Action - getSales - End - Success');

        return ResultModel.newSuccessResult(getSales);
    }
    catch (error) {
        LoggerService.logInfo('Action - getSales - End - Error');
        const newErr = ErrorModel.newError({
            code: `${ACTION_CODE}/${FUNCTION_CODE}/ERROR`,
            message: 'Une erreur est survenue.',
            error: error
        });
        LoggerService.logError(error);

        return ResultModel.newErrorResult(newErr);
    }
}
